import { useUpdateUserProfile } from "@features/account/hooks/useUpdateUserProfile";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { EditNameDialog } from "@memorang/ui/components/AccountSettingsApplet/dialogs/EditNameDialog";
import { useMemo, useState } from "react";
import { useDialog } from "../DialogContext";
import type { DialogSpec } from "../types";

const EditNameDialogContainer = ({ onClose }: { onClose: () => void }) => {
	const { firstName, lastName } = useAuthContext();
	const { saveProfile } = useUpdateUserProfile();
	const [error, setError] = useState<string>();
	const [isSaving, setIsSaving] = useState(false);

	const handleSave = async (names: {
		firstName: string;
		lastName: string;
	}) => {
		setError(undefined);
		setIsSaving(true);
		const result = await saveProfile(names);
		setIsSaving(false);

		if (result.ok) {
			onClose();
			return;
		}

		setError(result.error);
	};

	return (
		<EditNameDialog
			visible
			onClose={onClose}
			initialFirstName={firstName ?? ""}
			initialLastName={lastName ?? ""}
			onSave={handleSave}
			isSaving={isSaving}
			error={error}
		/>
	);
};

export const editNameDialog: DialogSpec<"editName"> = {
	render: ({ onClose }) => <EditNameDialogContainer onClose={onClose} />,
};

export const useEditNameDialog = () => {
	const { showDialog, hideDialog } = useDialog();
	return useMemo(
		() => ({
			showEditName: () => showDialog("editName", {}),
			hideEditName: () => hideDialog("editName"),
		}),
		[showDialog, hideDialog],
	);
};
